import React from 'react';
import { useFilteredProjects } from './useFilteredProjects';
import { containerCss } from './styles';
import { NotFound } from './NotFound';
import { MissionCard } from './card/MissionCard';
import { generateProjectId } from './useFilteredMissions';
import { UserType } from '../../../../consts/userType';
import { Alert } from '@traceair/tds';
import { useCurrentUserType } from '../../../../hooks/useCurrentUserType';
import { stylesheet } from 'typestyle';

const css = stylesheet({
  moderatorAlert: {
    marginBottom: 24,
  },
});

export const ProjectsTab = () => {
  const projects = useFilteredProjects();
  const userType = useCurrentUserType();

  if (!projects.length) {
    return <NotFound />;
  }

  return (
    <div className={containerCss.container}>
      {userType === UserType.Moderator && (
        <Alert
          className={css.moderatorAlert}
          type="attention"
          title="You have moderator access"
          description="To avoid overloading AT, moderators can see project-level details and COA only for projects from the 'Scheduled' tab."
        />
      )}
      {projects.map(({ customer, site }) => (
        <MissionCard key={generateProjectId(customer, site)} customer={customer} site={site} />
      ))}
    </div>
  );
};
